import React from 'react';
import { DocumentTextIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import styles from './Payments.module.css';

const InvoicesCard = ({ isEnabled, onClick }) => {
  return (
    <div 
      className={`${styles.actionCard} ${styles.invoicesCard} ${isEnabled ? styles.enabled : styles.disabled}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
      aria-label={isEnabled ? "View and manage invoices" : "Invoices - setup required"}
    >
      <div className={styles.cardIconWrapper}>
        <DocumentTextIcon className={styles.cardIcon} />
      </div>
      
      <h3 className={styles.cardTitle}>Invoices</h3>
      <p className={styles.cardDescription}>
        Create professional invoices, track payments, and manage your billing workflow
      </p>
      
      <button 
        className={`${styles.cardButton} ${!isEnabled ? styles.disabled : ''}`}
        disabled={!isEnabled}
        onClick={(e) => {
          e.stopPropagation();
          if (isEnabled) {
            onClick();
          }
        }}
        type="button"
      >
        {isEnabled ? (
          <>
            View and Create invoices
            <ChevronRightIcon className={styles.cardArrow} />
          </>
        ) : (
          'Setup Required'
        )}
      </button>
    </div>
  );
};

export default InvoicesCard;
